import { render, staticRenderFns } from "./SelectCustomer.vue?vue&type=template&id=d0982674&scoped=true"
import script from "./SelectCustomer.vue?vue&type=script&lang=js"
export * from "./SelectCustomer.vue?vue&type=script&lang=js"
import style0 from "./SelectCustomer.vue?vue&type=style&index=0&id=d0982674&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0982674",
  null
  
)

export default component.exports